module.exports = __webpack_public_path__ + "img/log-integrations.2f984c5b.svg";